import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCanStyle0 = gravityIconIndividualCss;

const GravityIconCan = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '2cda3273984b9d9dd3db1a3fb969462d75c52630', color: this.color, size: this.size }, h("svg", { key: '08d7660990078c5e8a254cb1f87af211f006f441', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'afcc9d267677718e82c6a0232b17485d242c1590', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 5.5c0-1.778-1.977-3-4.5-3-2.523 0-4.5 1.222-4.5 3v11.644C6.5 18.69 8.764 19.5 11 19.5s4.5-.81 4.5-2.356V5.5ZM11 4c1.654 0 3 .673 3 1.5 0 .627-1.141 1.5-3 1.5s-3-.873-3-1.5C8 4.673 9.346 4 11 4ZM8 17.144v-4.93a5.43 5.43 0 0 0 2.94.8l1.911-4.777a5.022 5.022 0 0 0 1.149-.5v4.494a5.477 5.477 0 0 1-3 .8h-.052l-1.882 4.7c-.647-.195-1.019-.453-1.066-.587Z", fill: "currentColor" }))));
    }
};
GravityIconCan.style = GravityIconCanStyle0;

export { GravityIconCan as gravity_icon_can };

//# sourceMappingURL=gravity-icon-can.entry.js.map